import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { MessageBoxPosition, MessageType, showMessageBox } from "../redux/message-box.slice";

export interface MessageBoxOptions {
    message: string;
    messageType: MessageType;
    duration: number;
    position?: MessageBoxPosition
}

/**
 * Returns a memoized dispatcher for raising toast messages.
 * @returns Function that enqueues a message box with the provided options.
 */
export function useShowMessage() {

    const dispatch = useDispatch();

    return useCallback(
        (options: MessageBoxOptions) => {
            dispatch(showMessageBox(options));
        },
        [dispatch]
    );
}
